import { IRootState } from '../reducer'
import { prefix } from './actions'

export const isLoading = (state: IRootState) => state[prefix].loadingArray.length > 0

export const data = (state: IRootState) => state[prefix].data

export const ongoingReporting = (state: IRootState) => state[prefix].ongoingReporting

export const dataConsolidated = (state: IRootState) => state[prefix].dataConsolidated

export const dataConsolidatedMultipleReports = (state: IRootState) =>
  state[prefix].dataConsolidatedMultipleReports

export const financialsDrillDown = (state: IRootState) => state[prefix].financialsDrillDown.data

export const dataSummary = (state: IRootState) => state[prefix].dataSummary

export const dataSummaryReconciliation = (state: IRootState) =>
  state[prefix].dataSummaryReconciliation

export const dataSummaryHeaders = (state: IRootState) => state[prefix].dataSummaryHeaders

export const dataSummaryHeadersColors = (state: IRootState) =>
  state[prefix].dataSummaryHeadersColors

export const dataSummaryHeadersData = (state: IRootState) => state[prefix].dataSummaryHeadersData

export const dataSummaryGrowth = (state: IRootState) => state[prefix].dataSummaryGrowth

export const reportingUpdatesList = (state: IRootState) => state[prefix].reportingUpdatesList

export const skuDetails = (state: IRootState) => state[prefix].skuDetails

export const skuVisualization = (state: IRootState) => state[prefix].skuVisualization

export const skuVisualizationsFilters = (state: IRootState) =>
  state[prefix].skuVisualizationsFilters

export const salesByDistributionGraph = (state: IRootState) =>
  state[prefix].salesByDistributionGraph
